export const UI_CONSTANTS = {
    CUSTOM_BREAKPOINTS: {
        XL: 1280,
    },
};